import React from "react";
import { OFFERS } from "../config/siteConfig";
import { scrollToSection } from "../config/utils";
import ParallaxCard from "./ParallaxCard";

const Offers = () => {
  return (
    <section id="offers" className="py-24 bg-black">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-amber-600/60 tracking-[0.3em] uppercase text-xs mb-4">
            Nos tarifs
          </p>
          <h2
            className="text-4xl md:text-5xl mb-4 font-display"
            style={{ color: "#BB9D63" }}
          >
            Nos formules
          </h2>
          <p className="text-zinc-500 max-w-md mx-auto text-sm">
            Des offres adaptées à tous vos événements, de l'intime au grandiose.
          </p>
        </div>

        {/* Cartes 3D parallax */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8 mb-16">
          {OFFERS.map((offer) => (
            <ParallaxCard key={offer.id} offer={offer} />
          ))}
        </div>

        {/* Détails des features */}
        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {OFFERS.map((offer) => (
            <div
              key={offer.id + "-details"}
              className="p-6 rounded-sm border border-white/5 bg-zinc-950/50"
            >
              <h4 className="text-lg font-semibold text-white mb-1 font-display">
                {offer.title}
              </h4>
              <p className="text-zinc-600 text-xs mb-4">
                {offer.persons} · {offer.price} / {offer.duration}
              </p>
              <ul className="space-y-2.5">
                {offer.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-2.5">
                    <svg
                      className="w-3.5 h-3.5 mt-0.5 flex-shrink-0"
                      viewBox="0 0 20 20"
                      fill={offer.accent}
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span className="text-zinc-400 text-sm">{f}</span>
                  </li>
                ))}
              </ul>
              <button
                onClick={() => scrollToSection("contact")}
                className="mt-6 w-full py-3 text-sm tracking-wider uppercase rounded-sm transition-all duration-300 border hover:text-black"
                style={{
                  borderColor: offer.accent + "40",
                  color: offer.accent,
                }}
                onMouseEnter={(e) => {
                  (e.target as HTMLElement).style.background = offer.accent;
                  (e.target as HTMLElement).style.color = "#000";
                }}
                onMouseLeave={(e) => {
                  (e.target as HTMLElement).style.background = "transparent";
                  (e.target as HTMLElement).style.color = offer.accent;
                }}
              >
                Choisir
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offers;
